<template>
	<div>
		<!-- Name -->
		<div class="xs-12 mb6" v-if="hasName">
			<core-form-input
				name="name"
				componentName="j-base-input-text"
				:label="$t('name')"
				v-model="updatedData.name"
				size="medium"
			/>
		</div>

		<!-- Description -->
		<div class="xs-12 mb6" v-if="hasDescription">
			<core-form-input
				name="description"
				componentName="j-base-input-text"
				:label="$t('description')"
				v-model="updatedData.description"
				size="medium"
			/>
		</div>

		<!-- Value -->
		<div class="flex xs-12 wrap xs-top mb6" v-if="hasValue">
			<div class="xs-12 c1 fw7 lh125">{{ $t("value") }}</div>
			<div class="xs-12">
				<scalar-value-input v-model="updatedData.value" size="medium" />
			</div>
		</div>

		<!-- Currency -->
		<div class="flex xs-12 wrap xs-top mb6" v-if="hasCurrency">
			<div class="xs-12 c1 fw7 lh125">{{ $t("currency") }}</div>
			<div class="xs-12">
				<core-select-currency
					v-model="updatedData.currencyCode"
					:allowSelectNothing="true"
					size="medium"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import ScalarValueInput from "./ScalarValueInput"
import CoreSelectCurrency from "@/modules/core/components/CoreSelectCurrency"
import CoreFormInput from "@/modules/core/components/CoreFormInput"

export default {
	components: { ScalarValueInput, CoreSelectCurrency, CoreFormInput },

	props: {
		data: {
			type: Object,
			default: () => ({
				name: "",
				description: "",
				value: { numberValue: 0 },
				currencyCode: null
			})
		},
		hasName: {
			type: Boolean,
			default: true
		},
		hasDescription: {
			type: Boolean,
			default: true
		},
		hasCurrency: {
			type: Boolean,
			default: true
		},
		hasValue: {
			type: Boolean,
			default: true
		}
	},

	data() {
		return {
			updatedData: { ...this.data }
		}
	},

	watch: {
		/**
		 * Anytime there is an update, emit input event
		 */
		updatedData: {
			handler(newVal, oldVal) {
				this.$emit("input", newVal)
			},
			immediate: false,
			deep: true
		}
	}
}
</script>